import { getFilterSet, getFilterSetWithGroupId, getFilterSetWithSearch, getProductCategory, getProductList, getProductParent } from "../../../pages/api/hello";

export async function loadProductCategory() {
    try {
        let res: any = await getProductParent("?limit=25&page=1");

        if (res) {
            return res?.results
        }
    } catch (error) {

    }
}

export async function loadFilterSet(group_id?: string) {
    try {
        let res: any = null;
        if (group_id) {
            res = await getFilterSetWithGroupId(group_id);
        } else {
            res = await getFilterSet();
        }

        if (res) {
            return res?.results;
        }
    } catch (error) {

    }
}

export async function loadFilterSetSearch(search?: string) {
    try {
        let res: any = null;
        if (search) {
            res = await getFilterSetWithSearch(search);
        } else {
            res = await getFilterSet();
        }

        if (res) {
            return res?.results;
        }
    } catch (error) {

    }
}

export async function loadProductGroupFilterSet() {
    try {
        let res: any = await getProductCategory();

        if (res) {
            //await setProductGroups(res?.results);
            //localStorage.setItem(constant.groupName, res?.results[activeType]?.name);
            return res?.results;
        }
    } catch (error) {

    }
}

export async function loadProductsData(filter?: any) {
    try {
        if (filter?.group_id !== 0 && filter?.group_id) {
            let res: any = await getProductList(`limit=${20}&page=${1}&from_date=${""}&to_date=${""}`, filter);

            if (res) {
                return {
                    page: 1,
                    from_date: "",
                    to_date: "",
                    limit: 20,
                    totalPages: res.totalPages,
                    filter: filter,
                    datas: res.results
                };
            }
        }
    } catch (error) {

    }
}